export const getWebFormScript = formId => {
  // If we're on the dev environment give them the dev script
  if (window.location.host.includes('marketing-dev.cinch.io')) {
    return `<script src="https://dev.poquett.com/js/script.min.js" data-uuid="${formId}" data-env="dev"></script>`;
  }
  return `<script src="https://poquett.com/js/script.min.js" data-uuid="${formId}"></script>`;
};